import styled from 'styled-components/macro'

export const AppletIcon = styled.div`
  aspect-ratio: 1;
  width: 100%;
  height: 100%;
  border-color: white;
  color: white;
`
